export const ITEMS_PER_PAGE = 10;

export const POPUP_CLOSE_TIME = 2000;

export const SEARCH_DEBOUNCE_TIME = 400;

/**
 * @description
 * This constant is used for maximum number of licenses that can be added for a school or organization
 * @type {number}
 */
export const MAX_LICENSE_ADD_ON = 10000;

/**
 *@type {Object} ERROR_MESSAGES
 *@param {string} INTERNAL_SERVER
 *@param {string} NETWORK_ERROR
 *@param {string} UNAUTHORIZED
 *@param {string} FORBIDDEN
 *@param {string} NOT_FOUND
 *@param {string} UNKNOWN
 */

/**
 * @description
 * This constant is used for error messages
 * @typedef {Object} ERROR_MESSAGES
 */
export const ERROR_MESSAGES = {
  INTERNAL_SERVER:
    "Something went wrong on our side. Please try again in a moment.",
  NETWORK_ERROR: "Unable to connect. Please check your internet connection.",
  UNAUTHORIZED: "Login failed. Please check your credentials.",
  FORBIDDEN: "You don’t have permission to perform this action.",
  NOT_FOUND: "Requested data not found.",
  UNKNOWN: "An unexpected error occurred. Please try again.",
};

/**
 * @description
 * Language preference options for school settings.
 * `value: null` means "Student Decides" (no forced locale).
 * @type {Array<{ label: string, value: "en" | "hi" | null }>}
 */
export const LANGUAGE_OPTIONS = [
  { label: "English", value: "en" },
  { label: "Hindi", value: "hi" },
  { label: "Student Decides", value: null },
];
